import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
import App from './App'
import router from './router'
import { OPEN_LOGIN, OPEN_CREATE } from 'common/js/login_back'
import { phoneIs, phoneXIs, ismaoyanBoole, iphone, getNumberPrice, isWeixin } from 'common/js/util'
import Bridge from 'common/js/bridge.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.prototype._isWeixin = function() {
let weixin = isWeixin()
return weixin
}
Vue.config.productionTip = false
Vue.prototype._OPEN_LOGIN = OPEN_LOGIN
Vue.prototype._OPEN_CREATE = OPEN_CREATE
Vue.use(Vuex)
Vue.use(ToastPlugin)
Vue.prototype.$bridge = Bridge
Vue.prototype._ismaoyanBoole = function () {
let ismaoyan = ismaoyanBoole()
return ismaoyan
}
Vue.prototype._getNumberPrice = function (number) {
return getNumberPrice(number)
}
Vue.prototype._iphone = function () {
return iphone()
}
Vue.prototype._phoneIs = function () {
return phoneIs()
}


new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})
export const _vue = Vue












